import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Border = 'dashed' | 'solid';

export interface EmptyProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  cta?: ReactNode;
  border?: Border;
  className?: string;
}

export function Empty({
  icon = '∅',
  title,
  description,
  cta,
  border = 'dashed',
  className,
}: EmptyProps) {
  return (
    <div
      className={clsx(
        'rounded-xl bg-bg-card text-center px-6 py-8',
        border === 'dashed' ? 'border border-dashed border-line' : 'border border-line',
        className,
      )}
    >
      <div className="mx-auto mb-2.5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-bg-elevated text-fg-muted text-base">
        {icon}
      </div>
      {title && <h5 className="text-sm font-bold tracking-heading">{title}</h5>}
      {description && <p className="mt-1 text-xs text-fg-muted">{description}</p>}
      {cta && <div className="mt-3.5">{cta}</div>}
    </div>
  );
}
